import {
  Box,
  Button,
  Container,
  FormControlLabel,
  Grid,
  IconButton,
  makeStyles,
  OutlinedInput,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  useTheme,
} from "@material-ui/core";
import { Camera, CameraAlt, Edit } from "@material-ui/icons";
import React, { useState, useEffect } from "react";
import { Fragment } from "react";
import { Helmet } from "react-helmet";
import { PageBanner } from "../../components";
import { BookTypes, Delivery, Reviews, Category } from "./components";
import { useSelector, useDispatch } from "react-redux";
import { updateBook } from "../../redux-store/author/author";
import { useHistory, useParams } from "react-router";
import { backend } from "../../api";
import { toast, ToastContainer } from "react-toastify";
import Swal from "sweetalert2";
import { Skeleton } from "@material-ui/lab";
import ChangeCoverModal from "./components/Modals/ChangeCoverModal";
import { editBook, fetchBookDetails } from "../../redux-store/books/actions";
import { RESET_BOOK } from "../../redux-store/constants";

const useStyles = makeStyles((theme) => ({
  bookTitle: {
    margin: 0,
    fontSize: 32,
    fontWeight: 550,
  },
  changePicBtn: {
    opacity: "0.8",
    marginTop: "-100px",
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.secondary.light,

    "&:hover": {
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.secondary.light,
    },
  },
  bookCoverContainer: {
    width: "90%",
    maxWidth: 200,
    margin: "0 auto",
  },
  bookCover: {
    width: "100%",
    objectFit: "contain",
    height: 300,
  },
}));

function BookSetting() {
  const [editMode, setEditMode] = useState(false);
  const [bookName, setBookName] = useState("");
  const [bookStory, setBookStory] = useState("");
  const [demand, setDemand] = useState("");
  const { currentBook, error, loading } = useSelector((state) => state.book);
  const [coverModal, setCoverModal] = useState(false);
  const dispatch = useDispatch();
  const classes = useStyles();
  const theme = useTheme();
  const params = useParams();
  useEffect(() => {
    dispatch({ type: RESET_BOOK });
  }, []);

  useEffect(() => {
    if (!currentBook) {
      dispatch(fetchBookDetails(params.bookId));
    } else {
      setBookName(currentBook?.book_title);
      setBookStory(currentBook?.book_story);
      setDemand(currentBook?.print_on_demand);
    }
  }, [currentBook]);

  const handleCoverModalOpen = () => {
    setCoverModal(true);
  };
  const handleCoverModalFalse = () => {
    setCoverModal(false);
    dispatch(fetchBookDetails(params.bookId));
  };
  const handleEditBook = () => {
    const updaTedBook = {
      book_title: bookName,
      book_story: bookStory,
      print_on_demand: demand,
      id: currentBook._id,
    };
    dispatch(editBook(updaTedBook));
    setEditMode(false);
  };

  return (
    <Fragment>
      <Helmet>
        <title>Book</title>
      </Helmet>
      <ToastContainer />
      <PageBanner
        image={"/assets/images/bg4.jpg"}
        title={"Book Setting"}
        size="small"
        titleAlign="left"
      />
      <Container style={{ marginTop: "40px" }}>
        {currentBook?.isPublished ? (
          <Grid container spacing={3}>
            <Grid item xs={12} sm={5} md={4} lg={3} align="center">
              <Box>
                {currentBook.book_cover ? (
                  <Box className={classes.bookCoverContainer}>
                    <img
                      src={currentBook.book_cover}
                      className={classes.bookCover}
                    />
                    {/* {editMode &&
                                <IconButton style={{}}>
                                    <CameraAlt />
                                </IconButton>} */}
                    <IconButton
                      className={classes.changePicBtn}
                      onClick={handleCoverModalOpen}
                    >
                      <CameraAlt />
                    </IconButton>
                  </Box>
                ) : (
                  <Box className={classes.bookCoverContainer}>
                    <Skeleton variant="rect" width="100%" height={300} />
                  </Box>
                )}
              </Box>
            </Grid>
            <Grid item xs={12} sm={7} md={8} lg={9}>
              <Box>
                {editMode ? (
                  <Box>
                    <TextField
                      variant="outlined"
                      label="Title"
                      value={bookName}
                      style={{ width: "100%", maxWidth: 600, padding: 10 }}
                      onChange={(e) => setBookName(e.target.value)}
                    />
                    <TextField
                      variant="outlined"
                      label="Story"
                      value={bookStory}
                      style={{ width: "100%", maxWidth: 600, padding: 10 }}
                      multiline
                      onChange={(e) => setBookStory(e.target.value)}
                    />
                    {/* <RadioGroup
                      defaultValue={demand}
                      onChange={(e) => setDemand(e.target.value)}
                    >
                      <FormControlLabel
                        value="author"
                        label="Myself"
                        control={<Radio />}
                      />
                      <FormControlLabel
                        value="admin"
                        label="d2p"
                        control={<Radio />}
                      />
                    </RadioGroup> */}
                  </Box>
                ) : (
                  <Box>
                    {currentBook.book_title ? (
                      <h1 className={classes.bookTitle}>
                        {currentBook.book_title}
                      </h1>
                    ) : (
                      <Skeleton
                        animation="wave"
                        variant="rect"
                        width="90%"
                        height={50}
                      />
                    )}
                    {currentBook.book_story ? (
                      <p>{currentBook.book_story}</p>
                    ) : (
                      <Box my={2}>
                        <Skeleton animation="wave" width="60%" />
                        <Skeleton animation="wave" width="40%" />
                      </Box>
                    )}
                    {/* {currentBook.print_on_demand ? (
                      <Box textAlign="center">
                        <Typography
                          variant="h6"
                          style={{ color: theme.palette.primary.dark }}
                        >
                          Print{" "}
                          {currentBook.print_on_demand === "author"
                            ? " by MYSELF"
                            : "through d2p"}
                        </Typography>
                      </Box>
                    ) : (
                      <Skeleton animation="wave" width={200} />
                    )} */}
                  </Box>
                )}
                {editMode ? (
                  <>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={() => handleEditBook()}
                    >
                      Update
                    </Button>
                    <Button
                      style={{ marginLeft: "3px" }}
                      variant="outlined"
                      color="secondary"
                      onClick={() => setEditMode(false)}
                    >
                      Cancel
                    </Button>
                  </>
                ) : (
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => setEditMode(true)}
                  >
                    Edit
                  </Button>
                )}
                <Box textAlign="right">
                  {currentBook.isPublished
                    ? currentBook.isActive
                      ? "Active"
                      : "In Active"
                    : currentBook.isBlacklisted
                    ? "Blacklisted"
                    : "Requested"}
                </Box>
              </Box>
              {currentBook.isApproved && (
                <p style={{ color: theme.palette.success.main, margin: "0" }}>
                  Approved
                </p>
              )}
              <BookTypes bookId={params.bookId} currentBook={currentBook} />
             
              <Category bookId={params.bookId} currentBook={currentBook} />
              <Reviews
                reviews={currentBook.reviews}
                bookId={currentBook._id}
                currentBook={currentBook}
              />
            </Grid>
          </Grid>
        ) : (
          <Box>
            <Skeleton variant="h1" animation="wave" />
            <Skeleton variant="rect" animation="wave" />
          </Box>
        )}
      </Container>
      <ChangeCoverModal
        visible={coverModal}
        closeModal={handleCoverModalFalse}
        bookId={params.bookId}
      />
    </Fragment>
  );
}

export default BookSetting;
